export default __webpack_public_path__ + "static/dont-leading-visual-color-781fa5a9b5de24102f3ca5f5b3a38890.png";